import { type MCPServerInfo } from '../../types';

const SelectStarServer: MCPServerInfo = {
  serverId: 'SELECT_STAR',
  name: 'Select Star',
  slug: 'select-star',
  description:
    'Select Star MCP Server for data lineage and metadata management',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.production.selectstar.com/mcp'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['selectstarAccessToken'],
    properties: {
      selectstarAccessToken: {
        type: 'string',
        description: 'The API token for accessing the Select Star MCP server.',
        sensitive: true
      }
    }
  }
};

export default SelectStarServer;
